import { render, staticRenderFns } from "./RichSnippet.vue?vue&type=template&id=2fcf9913&"
import script from "./RichSnippet.vue?vue&type=script&lang=js&"
export * from "./RichSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports